<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import { onMounted } from "vue"

onMounted(() => {
  $("#report_pt")
    .dataTable({
      paging: false,
      info: false,
      searching: true,
      dom: "t",
      order: [[0, "desc"]],
      columnDefs: [
        { targets: "no-sort", orderable: false },
        { type: "title-numeric", targets: [0, 1, 2, 3] },
        { orderSequence: ["desc", "asc"], targets: [0, 1, 2] },
      ],
    })
})
</script>
